export enum MapViewType {
    ROADMAP = 0,
    SATELLITE = 1,
    TERRAIN = 2,
    HYBRID = 3,
}
